import { defineAsyncComponent } from 'vue'
import { applyChartDefaults } from '../utils/chartTheme'

// Global kayıt ilk pakete apexcharts'ı eklemesin diye bileşen ilk kullanımda ayrı chunk'tan gelir (Aşama 3).
// Aşama 4.6: vue3-apexcharts. Prop'lar, ref ve olaylar iç bileşene geçer.
// Ortak görünüm (`window.Apex`) paketi beklemez: sözlük ilk grafik çizilmeden önce hazırdır.
export default {
  install(app) {
    applyChartDefaults()
    app.component('apexchart', defineAsyncComponent(() => import(/* webpackChunkName: "apexcharts" */ 'vue3-apexcharts')))
  }
}
